import PageHeadingWithBackButton from './PageHeadingWithBackButton';

export default PageHeadingWithBackButton;
